import React from 'react'

export const StatusPill = ({ tone = 'secondary', children }) => (
    <span className={`rt-pill rt-pill-${tone}`}>{children}</span>
)
